/**
 * The document shown in every HTML preview frame. Three layers keep an
 * imported newsletter away from the admin session:
 *   1. the frame is `sandbox=""` (no scripts, no same-origin, no forms,
 *      no popups, no top navigation) — set by the component that renders it;
 *   2. this Content-Security-Policy forbids everything except inline styles
 *      and https/data images and fonts (no scripts, frames, forms, fetch);
 *   3. links are inert.
 * The HTML passed in is already the server's sanitised output; this is the
 * second line of defence, not the first.
 */
export const PREVIEW_CSP =
  "default-src 'none'; img-src https: data:; style-src 'unsafe-inline'; font-src https:; form-action 'none'; base-uri 'none'";

export function htmlPreviewDocument(html: string): string {
  return (
    '<!doctype html><html><head><meta charset="utf-8">' +
    `<meta http-equiv="Content-Security-Policy" content="${PREVIEW_CSP}">` +
    '<style>html,body{margin:0}a{pointer-events:none;cursor:default}img{max-width:100%}</style>' +
    `</head><body>${html}</body></html>`
  );
}
